import React, { useState } from "react";
import { doc, updateDoc, arrayUnion, increment } from "firebase/firestore";
import { db } from "../firebase/firestore"; // Make sure to import your Firestore configuration
import { useUser } from "../context/userContext"; // Ensure you have a context to get the user id
import { IoCheckmarkCircleSharp } from "react-icons/io5";

const manualTasks = [
  {
    title: "Join our Telegram Channel",
    link: "https://t.me/cheeseartlabs",
    icon: "/telegram.svg",
    id: 1,
    chatId: "",
    reward: "10 Roullete Spins",
    bonus: 10,
    slot: 0,
    no: 0,
    isSocial: true,
  },
  {
    title: "Follow CheeseArt on Twitter",
    link: "https://x.com/cheeseartio",
    icon: "/twitter2.svg",
    id: 2,
    chatId: "",
    reward: "10 Roullete Spins & 1 Slot Spin",
    bonus: 10,
    slot: 1,
    no: 0,
    isSocial: true,
  },
  {
    title: "Follow Catvegas on Twitter",
    link: "https://x.com/catvegas_",
    icon: "/twitter2.svg",
    id: 3,
    chatId: "",
    reward: "10 Roullete Spins & 1 Slot Spin",
    bonus: 10,
    slot: 1,
    no: 0,
    isSocial: true,
  },
  {
    title: "Subscribe to CheeseArt on Youtube",
    link: "https://www.youtube.com/channel/UCDPu4gy8l8-zYmA8KQcDKYw",
    icon: "/youtube.svg",
    id: 4,
    chatId: "",
    reward: "10 Roullete Spins & 1 Slot Spin",
    bonus: 10,
    slot: 1,
    no: 0,
    isSocial: true,
  },
  {
    title: "Follow CheeseArt on Instagram",
    link: "https://www.instagram.com/cheeseartlabs/",
    icon: "/instagram.svg",
    id: 5,
    chatId: "",
    reward: "10 Roullete Spins",
    bonus: 10,
    slot: 0,
    no: 0,
    isSocial: true,
  },
  {
    title: "Invite a friend ",
    link: "",
    icon: "/coin.webp",
    id: 6,
    chatId: "",
    reward: "",
    bonus: 10000,
    no: 1,
    claimId: 1,
    isSocial: false,
  },
  {
    title: "Invite 3 friends ",
    link: "",
    icon: "/coin.webp",
    id: 7,
    chatId: "",
    reward: "",
    bonus: 50000,
    no: 3,
    claimId: 2,
    isSocial: false,
  },
  {
    title: "Invite 5 friends ",
    link: "",
    icon: "/coin.webp",
    id: 8,
    chatId: "",
    reward: "",
    bonus: 80000,
    no: 5,
    claimId: 3,
    isSocial: false,
  },
];

const ManualTasks = () => {
  const [modalOpen, setModalOpen] = useState(false);
  const [modalMessage, setModalMessage] = useState("");
  const [claiming, setClaiming] = useState({});
  const [isClaiming, setIsClaiming] = useState(false);
  const [verifying, setVerifying] = useState({});
  const [performedTasks, setPerformedTasks] = useState({});
  const {
    id: userId,
    userManualTasks,
    setUserManualTasks,
    setBalance,
    referrals,
    setReferralClaim,
    referralClaim,
    setEnergy,
    setSpinLimit,
  } = useUser(); // Assuming 'id' is the user's document ID in Firestore
  const [congrats, setCongrats] = useState(false);

  const performTask = (taskId) => {
    const task = manualTasks.find((task) => task.id === taskId);
    if (task) {
      window.open(task.link, "_blank");
      setTimeout(() => {
        setPerformedTasks((prev) => ({ ...prev, [taskId]: true }));
      }, 3500);
    }
  };

  const verifyTask = async (taskId) => {
    setVerifying((prev) => ({ ...prev, [taskId]: true }));
    try {
      // Create a promise that resolves after 12 seconds
      await new Promise((resolve) => setTimeout(resolve, 12000));
      const userDocRef = doc(db, "telegramUsers", userId);
      await updateDoc(userDocRef, {
        manualTasks: arrayUnion({ taskId: taskId, completed: true }),
      });

      // Show success message
      setModalMessage(
        <div className="w-full flex justify-center flex-col items-center space-y-3">
          <div className="w-full items-center justify-center flex flex-col space-y-2">
            <IoCheckmarkCircleSharp size={32} className="text-accent" />
            <p className="font-medium text-center">Verification Successful!</p>
          </div>
          <p className="pb-6 text-[15px] w-full text-center">
            Great job! You can now claim your reward by clicking the claim
            button.
          </p>
        </div>
      );
      setModalOpen(true);

      // Update local state
      setUserManualTasks((prev) => [...prev, { taskId, completed: false }]);
    } catch (error) {
      console.error("Error verifying task: ", error);
      setModalMessage(
        <div className="w-full flex justify-center flex-col items-center space-y-3">
          <p className="text-red-500">
            Failed to verify task. Please try again.
          </p>
        </div>
      );
      setModalOpen(true);
    } finally {
      setVerifying((prev) => ({ ...prev, [taskId]: false }));
    }
  };

  const claimTask = async ({ id, bonus, slot }) => {
    setClaiming((prev) => ({ ...prev, [id]: true }));
    try {
      const task = manualTasks.find((task) => task.id === id);
      const userDocRef = doc(db, "telegramUsers", userId);

      await updateDoc(userDocRef, {
        manualTasks: userManualTasks.map((task) =>
          task.taskId === id ? { ...task, completed: true } : task
        ),
        spinLimit: increment(slot),
        energy: increment(bonus),
      });
      setSpinLimit((prevSpinLimit) => prevSpinLimit + slot);
      setEnergy((prevEnergy) => prevEnergy + bonus);
      setUserManualTasks((prev) =>
        prev.map((task) =>
          task.taskId === id ? { ...task, completed: true } : task
        )
      );

      if (slot > 0) {
        setModalMessage(
          <div className="w-full flex justify-center flex-col items-center space-y-3">
            <div className="w-full items-center justify-center flex flex-col space-y-2">
              <IoCheckmarkCircleSharp size={32} className="text-accent" />
              <p className="font-medium text-center">Let's go!!</p>
            </div>
            <h3 className="font-medium text-[20px] text-[#ffffff] pt-2 pb-2">
              <p className="font-medium text-center">Task Completed</p>
              <span className="text-accent">
                +{formatNumberCliam(task.bonus)} Roullete Spins and +{slot} Slot
                Spins rewarded!{" "}
              </span>{" "}
            </h3>
            <p className="pb-6 text-[15px] w-full text-center">
              Keep performing new tasks! Something huge is coming! Perform more
              and earn more CHEESE now!
            </p>
          </div>
        );
      } else {
        setModalMessage(
          <div className="w-full flex justify-center flex-col items-center space-y-3">
            <div className="w-full items-center justify-center flex flex-col space-y-2">
              <IoCheckmarkCircleSharp size={32} className="text-accent" />
              <p className="font-medium text-center">Let's go!!</p>
            </div>
            <h3 className="font-medium text-[20px] text-[#ffffff] pt-2 pb-2">
              <p className="font-medium text-center">Task Completed</p>
              <span className="text-accent">
                +{formatNumberCliam(task.bonus)} Roullete Spins rewarded!{" "}
              </span>{" "}
            </h3>
            <p className="pb-6 text-[15px] w-full text-center">
              Keep performing new tasks! Something huge is coming! Perform more
              and earn more CHEESE now!
            </p>
          </div>
        );
      }
      setModalOpen(true);
      setCongrats(true);

      setTimeout(() => {
        setCongrats(false);
      }, 4000);
    } catch (error) {
      console.error("Error claiming task: ", error);
    } finally {
      setClaiming((prev) => ({ ...prev, [id]: false }));
    }
  };

  // to claim the referla task reward
  const claimReward = async (point) => {
    setIsClaiming(true);
    try {
      const userDocRef = doc(db, "telegramUsers", userId);
      await updateDoc(userDocRef, {
        balance: increment(point),
        referralClaim: referralClaim + 1,
      });
      setBalance((prev) => prev + point);
      setReferralClaim((prev) => prev + 1);
    } catch (error) {
      console.error("Error claiming reward: ", error);
    } finally {
      setIsClaiming(false);
    }
  };

  const closeModal = () => {
    setModalOpen(false);
  };

  const formatNumber = (num) => {
    if (num < 100000) {
      return new Intl.NumberFormat().format(num).replace(/,/g, " ");
    } else if (num < 1000000) {
      return new Intl.NumberFormat().format(num).replace(/,/g, " ");
    } else {
      return (num / 1000000).toFixed(3).replace(".", ".") + " M";
    }
  };

  const formatNumberCliam = (num) => {
    if (num < 100000) {
      return new Intl.NumberFormat().format(num).replace(/,/g, " ");
    } else if (num < 1000000) {
      return new Intl.NumberFormat().format(num).replace(/,/g, " ");
    } else {
      return (num / 1000000).toFixed(3).replace(".", ".") + " M";
    }
  };

  return (
    <>
      {manualTasks
        .sort((a, b) => a.id - b.id)
        .map((task) => {
          const userTask = userManualTasks.find((t) => t.taskId === task.id);
          const isTaskCompleted = userTask?.completed;
          const isTaskSaved = !!userTask;
          const hasPerformed = performedTasks[task.id];

          return (
            <div
              key={task.id}
              className="w-full rounded-[16px] bg-[#000]  border border-[2px] border-[#a71414] p-4 pl-3 flex items-start space-x-3"
            >
              <div className="flex items-center justify-center">
                <img alt="engy" src={task.icon} className="w-[40px]" />
              </div>

              <div className="flex h-full w-full flex-col justify-center relative">
                <div className="flex w-full flex-col justify-between h-full space-y-3">
                  <h1 className="text-[15px] text-nowrap line-clamp-1 mr-[5px] font-semibold">
                    {task.title}
                  </h1>
                  <span className="flex items-center w-fit space-x-1 text-primary text-[14px] font-semibold">
                    <span
                      className={`w-[10px] h-[10px] bg-accent rounded-full flex items-center`}
                    ></span>
                    {!task.isSocial ? (
                      <span className="">
                        +{formatNumber(task.bonus)} points
                      </span>
                    ) : (
                      <span className="">{task.reward}</span>
                    )}
                  </span>

                  <div className="w-full flex items-center text-[14px] justify-between relative">
                    {task.isSocial && (
                      <>
                        {!isTaskSaved && !isTaskCompleted && (
                          <>
                            <button
                              onClick={() => performTask(task.id)}
                              className="w-fit py-[6px] px-4 font-medium bg-cards hover:bg-[#8a8a8a] text-[#fff] hover:text-[#000] ease-in duration-200 rounded-[6px]"
                            >
                              Perform
                            </button>
                            <button
                              onClick={() => verifyTask(task.id)}
                              disabled={!hasPerformed || verifying[task.id]}
                              className={`w-fit py-[6px] px-4 font-medium rounded-[6px] ${
                                !hasPerformed
                                  ? "bg-btn2 text-[#888]"
                                  : "bg-btn4 text-[#000]"
                              }`}
                            >
                              {verifying[task.id] ? "Verifying..." : "Verify"}
                            </button>
                          </>
                        )}
                      </>
                    )}
                    {!task.isSocial && (
                      <>
                        {referralClaim === task.claimId ? (
                          <button
                            disabled={true}
                            className="opacity-30 w-fit py-[6px] px-4 font-medium bg-btn4 text-[#000] rounded-[6px]"
                          >
                            Claimed
                          </button>
                        ) : (
                          <button
                            disabled={
                              referrals.length < task.no ||
                              referralClaim === task.claimId
                            }
                            onClick={() => claimReward(task.bonus)}
                            className={`${
                              referrals.length < task.no && `opacity-30`
                            } w-fit py-[6px] px-4 font-medium bg-btn4 text-[#000] hover:bg-[#8a8a8a] text-[#fff] hover:text-[#000] ease-in duration-200 rounded-[6px]`}
                          >
                            {isClaiming ? "Claiming" : "Claim reward"}
                          </button>
                        )}
                      </>
                    )}

                    {isTaskSaved && !isTaskCompleted && (
                      <button
                        onClick={() =>
                          claimTask({
                            id: task.id,
                            bonus: task.bonus,
                            slot: task.slot,
                          })
                        }
                        disabled={claiming[task.id]}
                        className="w-fit py-[6px] px-4 font-medium bg-btn4 text-[#000] rounded-[6px]"
                      >
                        {claiming[task.id] ? "Claiming..." : "Claim"}
                      </button>
                    )}

                    {isTaskCompleted && (
                      <>
                        <span className="w-fit py-[6px] px-4 font-medium bg-[#494949] text-[#b8b8b8] rounded-[6px]">
                          Completed
                        </span>
                        <span className="mr-[6px]">
                          <IoCheckmarkCircleSharp
                            size={24}
                            className="text-accent"
                          />
                        </span>
                      </>
                    )}
                  </div>
                </div>
              </div>
            </div>
          );
        })}

      <div className="w-full absolute top-[50px] left-0 right-0 flex justify-center z-50 pointer-events-none select-none">
        {congrats ? (
          <img src="/congrats.gif" alt="congrats" className="w-[80%]" />
        ) : (
          <></>
        )}
      </div>

      <div
        className={`${
          modalOpen === true ? "visible" : "invisible"
        } fixed top-[-12px] bottom-0 left-0 z-40 right-0 h-[100vh] bg-[#00000042] flex justify-center items-center backdrop-blur-[10px] px-4`}
      >
        <div
          className={`${
            modalOpen === true
              ? "opacity-100 mt-0 ease-in duration-300"
              : "opacity-0 mt-[100px]"
          } w-full bg-modal relative rounded-[16px] flex flex-col justify-center p-8`}
        >
          {modalMessage}

          <div className="w-full flex justify-center">
            <button
              onClick={closeModal}
              className={`bg-btn4 w-fit py-[10px] px-6 flex items-center justify-center text-center rounded-[12px] font-medium text-[16px]`}
            >
              Continue tasks
            </button>
          </div>
        </div>
      </div>
    </>
  );
};

export default ManualTasks;
